import defaultSettings from '@/settings'

const title = defaultSettings.title || '云职友途'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
